import React, { forwardRef, useImperativeHandle, useMemo } from 'react'
import CustomColumn from '../../../../../customControl/CustomColumn';
import Select from 'react-select';
import { isNullableWithZero, onlyNumeric } from '../../../../commonClass/CommonValidation';

const CancellationPolicySection = forwardRef(({
    ActivityCancellationPolicy, setActivityCancellationPolicy,
    dropdownData, formErrors, setFormErrors, disabled, setEditDisabled
}, ref) => {


    const maxValueLength = useMemo(() => {
        return ActivityCancellationPolicy?.ActivityManagePolicyTypeId === 1 ? 3 : 4;
    }, [ActivityCancellationPolicy?.ActivityManagePolicyTypeId])

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        if (name === "ActivityManagePolicyTypeId") {
            setActivityCancellationPolicy((prev) => ({
                ...prev,
                ActivityManagePolicyTypeId: value,
                NoShow: null,
                UpTo24Hrs: null,
                UpTo48Hrs: null,
                MoreThan48Hrs: null,
            }));

        }
        else {
            setActivityCancellationPolicy((prev) => ({ ...prev, [name]: value }));
        }
    }

    const ValidateCancellationPolicyForm = () => {
        let error = {};

        // if (isNullableWithZero?.includes(ActivityBasicInfoId) || isNullableWithZero?.includes(ActivityName)) {
        //     error.ActivityName = "Please select activity from Basic Informatio Tab."
        // }
        if (isNullableWithZero?.includes(ActivityCancellationPolicy?.ActivityManagePolicyTypeId)) {
            error.ActivityManagePolicyTypeId = "Cannot Leave blank,Input Is mandatory."
        }
        if (isNullableWithZero?.includes(ActivityCancellationPolicy?.ActivityManageCurrentStatusId)) {
            error.ActivityManageCurrentStatusId = "Cannot Leave blank, Input Is mandatory."
        }
        return error;
    }

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: true,
        ValidateCancellationPolicyForm: ValidateCancellationPolicyForm
    }));

    return (
        <>
            <div className="row">
                <CustomColumn colXLNum={4} colNum={6} colMDNum={6} colLabel={6} colChildren={6} labelText='Select Type' labelId='ActivityManagePolicyTypeId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='ActivityManagePolicyTypeId'
                        options={dropdownData?.policyTypeList}
                        value={dropdownData?.policyTypeList?.find((prev) => prev?.value === ActivityCancellationPolicy?.ActivityManagePolicyTypeId) || 0}
                        onChange={(e) => handleOnChange("ActivityManagePolicyTypeId", e ? e?.value : 0)}
                        isSearchable
                        isDisabled={disabled}
                        placeholder='Select Type'
                    />
                    {formErrors?.ActivityManagePolicyTypeId && <div className="text-danger text-start fs_14">{formErrors?.ActivityManagePolicyTypeId}</div>}
                </CustomColumn>

                <CustomColumn colXLNum={4} colNum={6} colMDNum={6} colLabel={6} colChildren={6} labelText='Current Status' labelId='ActivityManageCurrentStatusId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='ActivityManageCurrentStatusId'
                        options={dropdownData?.currentStatusList}
                        value={dropdownData?.currentStatusList?.find((prev) => prev?.value === ActivityCancellationPolicy?.ActivityManageCurrentStatusId) || 0}
                        onChange={(e) => handleOnChange("ActivityManageCurrentStatusId", e ? e?.value : 0)}
                        isSearchable
                        isDisabled={disabled}
                        placeholder='Current Status'
                    />
                    {formErrors?.ActivityManageCurrentStatusId && <div className="text-danger text-start fs_14">{formErrors?.ActivityManageCurrentStatusId}</div>}
                </CustomColumn>

                <div className="col-xl-10 col-md-12 col-12 mt-3 mb-2">
                    <div className="row">

                        <div className="col-md-3 col-12">
                            <label htmlFor="policyNoShow">No Show</label>
                            <input
                                className='form-control'
                                type="text"
                                name="policyNoShow"
                                id="policyNoShow"
                                value={ActivityCancellationPolicy?.NoShow || ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) ? Number(onlyNumeric(e.target.value)) : null
                                    if (ActivityCancellationPolicy?.ActivityManagePolicyTypeId === 1) {
                                        numberValue <= 100 &&
                                            handleOnChange("NoShow", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handleOnChange("NoShow", numberValue)
                                    }
                                }}
                                maxLength={maxValueLength}
                                disabled={disabled}
                                placeholder='No Show'
                            />
                        </div>

                        <div className="col-md-3 col-12">
                            <label htmlFor="policyUpTo24Hrs">Up To 24Hrs</label>
                            <input
                                className='form-control'
                                type="text"
                                name="policyUpTo24Hrs"
                                id="policyUpTo24Hrs"
                                value={ActivityCancellationPolicy?.UpTo24Hrs || ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) ? Number(onlyNumeric(e.target.value)) : null
                                    if (ActivityCancellationPolicy?.ActivityManagePolicyTypeId === 1) {
                                        numberValue <= 100 &&
                                            handleOnChange("UpTo24Hrs", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handleOnChange("UpTo24Hrs", numberValue)
                                    }
                                }}
                                maxLength={maxValueLength}
                                disabled={disabled}
                                placeholder='Up To 24Hrs'
                            />
                        </div>

                        <div className="col-md-3 col-12">
                            <label htmlFor="policyUpTo48Hrs">Up to 48 Hrs</label>
                            <input
                                className='form-control'
                                type="text"
                                name="policyUpTo48Hrs"
                                id="policyUpTo48Hrs"
                                value={ActivityCancellationPolicy?.UpTo48Hrs || ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) ? Number(onlyNumeric(e.target.value)) : null
                                    if (ActivityCancellationPolicy?.ActivityManagePolicyTypeId === 1) {
                                        numberValue <= 100 &&
                                            handleOnChange("UpTo48Hrs", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handleOnChange("UpTo48Hrs", numberValue)
                                    }
                                }}
                                maxLength={maxValueLength}
                                disabled={disabled}
                                placeholder='Up to 48 Hrs'
                            />
                        </div>

                        <div className="col-md-3 col-12">
                            <label htmlFor="policyMoreThan48Hrs">More Than 48 Hrs</label>
                            <input
                                className='form-control'
                                type="text"
                                name="policyMoreThan48Hrs"
                                id="policyMoreThan48Hrs"
                                value={ActivityCancellationPolicy?.MoreThan48Hrs || ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) ? Number(onlyNumeric(e.target.value)) : null
                                    if (ActivityCancellationPolicy?.ActivityManagePolicyTypeId === 1) {
                                        numberValue <= 100 &&
                                            handleOnChange("MoreThan48Hrs", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handleOnChange("MoreThan48Hrs", numberValue)
                                    }
                                }}
                                maxLength={maxValueLength}
                                disabled={disabled}
                                placeholder='More Than 48 Hrs'
                            />
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
});

export default CancellationPolicySection